<template>
  <main>
    <div
      :class="[
        'coupon-loging-wrapper',
        isDesktop ? 'display-desktop' : 'display_mobile',
      ]"
    >
      <MoveAnimation
        v-if="!isDesktop"
        :initX="displayHorizontal ? 1635 : 16"
        :initY="initY"
        :stopPosition="displayHorizontal ? 'left' : 'right'"
      >
        <div v-if="isRenderImgTips">
          <img
            class="coupon-container"
            v-lazy="getImageUrl"
            @click="showCouponPopup"
            alt="logo"
          />
        </div>
      </MoveAnimation>
      <div v-else>
        <div v-if="isRenderPCImgTips">
          <img
            class="coupon-container"
            v-lazy="getImageUrl"
            @click="showCouponPopup"
            alt="logo"
          />
        </div>
      </div>
    </div>
    <CouponPopupNotLogged
      :dataSource="dataSource"
      :show="showPopup"
      @close="closePopup"
      @popupShow="popupShow"
      :closeOnClickOverlay="displayHorizontal ? true : false"
      :page="page"
    />
  </main>
</template>
<script>
  import MoveAnimation from '@/components/MoveAnimation'
  import CouponPopupNotLogged from '@/components/CouponPopupNotLogged'
  import { mapState, mapGetters, mapMutations } from 'vuex'
  import { couponPopupShow } from '@/pages/firebase'
  import { pagePopupShow, pagePopupClick } from '@/pages/marketingFirebase.js'
  import { isMsaWebView } from '@/utils/msa'

  // 优惠券提示
  export default {
    name: 'coupon-notice',
    props: {
      imgsrc: {
        type: String,
        default: '',
      },
      dataSource: {
        type: Object,
        default: () => {},
      },
      page: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        show: true,
        showPopup: false,
      }
    },
    components: {
      MoveAnimation,
      CouponPopupNotLogged,
    },
    computed: {
      ...mapState(['isDesktop', 'gameName', 'isGetapps', 'region']),
      ...mapState('detail', ['couponUplogin']),
      ...mapGetters(['displayHorizontal', 'isGameABtest']),
      getImageUrl() {
        return this.imgsrc
      },
      isRenderImgTips() {
        const oldState = !!(this.show && !this.isGetapps)
        return oldState && !this.isDesktop
      },
      isRenderPCImgTips() {
        return this.isDesktop && !this.isGameABtest
      },
      activityInfo() {
        return this.dataSource.activity || {}
      },
      initY() {
        if (isMsaWebView()) return 50 // msa
        return this.displayHorizontal ? 50 : 200 // 浏览器横屏
      },
    },
    watch: {
      couponUplogin(newVal) {
        newVal && this.showCouponPopup()
      },
    },
    mounted() {},
    methods: {
      ...mapMutations(['detail/setCouponUplogin']),
      showCouponPopup() {
        pagePopupClick({
          page: this.gameName || 'home',
          act_id: this.activityInfo.activityId || '', // 活动编号
        })
        this.showPopup = true
      },
      closePopup() {
        this.showPopup = false
        this['detail/setCouponUplogin'](false)
      },
      popupShow({ activityId, show }) {
        if (show) {
          const page = this.gameName ? this.gameName : 'home'
          couponPopupShow({ act_id: activityId, popup_type: 'popup0', page }) // 未登录的弹窗

          // 优惠券未登录弹窗曝光
          pagePopupShow({
            page,
            act_id: activityId, // 活动编号
            popup_type: 'popup0',
          })
        }
      },
    },
  }
</script>
<style lang="scss" scoped src="./index.scss"></style>
<style lang="scss" scoped>
  @media screen and (min-device-width: 1080px) {
    @import './index_pc.scss';
  }
</style>
